module.exports = __webpack_public_path__ + "static/img/patent1.jpg";